/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import { useLazyQuery, gql } from '@apollo/client';

export const useInteracfetchurl = () => {
    //add variables:
    // {
    //     "interacFetchUrlRequest": {
    //       "customerRedirectURL": null,
    //       "fromPage": null,
    //       "languageId": null,
    //       "threatMetrixId": null,
    //       "userId": null
    //     }
    //   }
    
    const INTERAC_FETCH_URL_GQL = gql`
    query InteracFetchUrlResponse($interacFetchUrlRequest: InteracFetchURLRequest!) {
        interacfetchurl(interacFetchUrlRequest: $interacFetchUrlRequest) {
        interacURL
        }
    }
    `;

    const [fetchInteracUrl, fetchInteracUrlRes] = useLazyQuery(INTERAC_FETCH_URL_GQL);

    return {fetchInteracUrl, fetchInteracUrlRes};
}
